export const UI_LANGS = [
  ["fr", "Français"], ["en", "English"], ["nl", "Nederlands"], ["de", "Deutsch"], ["es", "Español"], ["it", "Italiano"],
  ["pt", "Português"], ["pl", "Polski"], ["ro", "Română"], ["cs", "Čeština"], ["sk", "Slovenčina"], ["hu", "Magyar"],
  ["el", "Ελληνικά"], ["sv", "Svenska"], ["da", "Dansk"], ["no", "Norsk"], ["fi", "Suomi"], ["ru", "Русский"],
  ["uk", "Українська"], ["tr", "Türkçe"], ["ar", "العربية"], ["he", "עברית"], ["fa", "فارسی"], ["hi", "हिन्दी"],
  ["bn", "বাংলা"], ["ur", "اردو"], ["zh", "中文"], ["ja", "日本語"], ["ko", "한국어"], ["vi", "Tiếng Việt"],
  ["id", "Bahasa Indonesia"], ["th", "ไทย"], ["ms", "Bahasa Melayu"], ["sw", "Kiswahili"],
];
const RTL = ["ar", "he", "fa", "ur"];
const KEY = "flonote_lang";

const detect = () => {
  const saved = localStorage.getItem(KEY);
  if (saved && UI_LANGS.some(([c]) => c === saved)) return saved;
  const nav = (navigator.language || "fr").slice(0, 2);
  return UI_LANGS.some(([c]) => c === nav) ? nav : "fr";
};

export const LANG = detect();
export const LOCALE = LANG === "fr" ? "fr-BE" : LANG;
let dict = {};

export async function initI18n() {
  document.documentElement.lang = LANG;
  document.documentElement.dir = RTL.includes(LANG) ? "rtl" : "ltr";
  if (LANG === "fr") return;
  try {
    const res = await fetch(`${process.env.PUBLIC_URL || ""}/locales/${LANG}.json`);
    if (res.ok) dict = await res.json();
  } catch {
    dict = {};
  }
}

export function t(key, vars) {
  let s = dict[key] || key;
  if (vars && typeof vars === "object") for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(v);
  return s;
}

export function setLanguage(code) {
  localStorage.setItem(KEY, code);
  window.location.reload();
}
